import React, { useContext, useEffect, useState } from 'react'
import card from '../../../assets/img/svg/card_icon.svg'
// import Google_Pay from '../../../assets/img/svg/Google_pay_icon.svg'
// import Apple_Pay from '../../../assets/img/svg/Apple_pay_icon.svg'
import delete_btn from '../../../assets/img/delete_btn.png'
import CustomModal from '../../../component/customModal'
import AddEditCreditCard from './addEditCreditCard'
import { deleteCard, getAllCards, setDefaultCard } from '../../../redux/slices/paymentSlice'
import { useDispatch, useSelector } from 'react-redux'
import { SpinnerContext } from '../../../context/spinnerContext'
import { errorToast, successToast } from '../../../util/Toast/toast'
import DeletePopup from '../../../component/deletePopup'
import { PaymentIcon } from 'react-svg-credit-card-payment-icons'
import { FREEZE_CLIENT_MSG } from '../../../util/constant'

const PaymentMethod = () => {
  const dispatch = useDispatch()
  const { user } = useSelector(({ auth }) => auth)
  const { changeLoader } = useContext(SpinnerContext)
  const { allCards } = useSelector(({ payment }) => payment)

  const [showCreditCardModal, setShowCreditCardModal] = useState(false)
  const [isRefresh, setIsRefresh] = useState(true)

  const [cardId, setCardId] = useState(null)
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const openDeleteModal = () => setIsDeleteModalOpen((prev) => !prev)

  const toggleCreditCardModal = () => setShowCreditCardModal(!showCreditCardModal)

  const handleAPICall = async (action, payload, successMessage, errorMessage) => {
    setIsRefresh(false)
    changeLoader(true)
    try {
      const response = await dispatch(action(payload))
      if (response?.payload?.status === 200) {
        successToast(response?.payload?.data?.status_message || successMessage)
        action === deleteCard && setIsRefresh(true)
      } else {
        errorToast(response?.payload?.data?.status_message || errorMessage)
      }
    } catch {
      errorToast('An unexpected error occurred.')
    } finally {
      changeLoader(false)
    }
  }

  const handleCardSelection = (client_card_id) =>
    handleAPICall(setDefaultCard, { client_card_id }, 'Main card updated successfully', 'Failed to update main card')

  const handleCardDelete = () => {
    handleAPICall(deleteCard, cardId, 'Card deleted successfully', 'Failed to delete card')
    openDeleteModal()
  }
  useEffect(() => {
    if (!isRefresh) return
    changeLoader(true)
    dispatch(getAllCards()).finally(() => {
      changeLoader(false)
      setIsRefresh(false)
    })
  }, [isRefresh])

  const handleAddCreditCard = () => {
    if (!user?.is_email_verified) {
      errorToast('Email not verified. Please verify email to continue')
      return
    }
    if(user?.is_freezed_client) {
      errorToast(FREEZE_CLIENT_MSG)
      return
    }
    toggleCreditCardModal()
  }

  const paymentOptions = [
    { id: 'card', imgSrc: card, name: 'Card' }
    // { id: 'google_pay', imgSrc: Google_Pay, name: 'Google Pay' },
    // { id: 'apple_pay', imgSrc: Apple_Pay, name: 'Apple Pay' }
  ]

  return (
    <>
      <div className="card mb-0 mt-3" style={{ border: '1px solid #57575733' }}>
        <div className="card-body">
          <h5 className="mb-3 edit_profile_text">Payment Method</h5>

          {/* Payment Options */}
          <div className="payment_options_main_sec mb-4">
            {paymentOptions.map(({ id, imgSrc, name }) => (
              <div className="payment_options" key={id}>
                <input className="option_click" type="radio" id={id} name="payment_option" value={id} defaultChecked={name === 'Card'} />
                <img className="card_img" src={imgSrc} alt={name} />
                <h5 className="option_name">{name}</h5>
              </div>
            ))}
          </div>

          {/* Card List */}
          {allCards?.total > 0 &&
            allCards?.cards?.map(({ client_card_id, card_type, last_four_digit, is_main }, index) => (
              <div className="card_detail_sec mb-3" key={index}>
                <div className="card_detail_data_sec">
                  <div className="d-flex align-items-center">
                    <input
                      className="option_click me-0"
                      type="radio"
                      id={`card-${index}`}
                      name="fav_language"
                      value={card_type}
                      defaultChecked={is_main}
                      onChange={() => handleCardSelection(client_card_id)}
                    />
                    <h6 className="card_number_text">
                      {card_type} {last_four_digit && `**** **** **** ${last_four_digit}`}
                    </h6>
                  </div>
                  <PaymentIcon type={card_type?.toLocaleLowerCase().replaceAll(' ','-')} width={50} className="img-fluid" />
                </div>
                {!user?.is_freezed_client && (
                  <button
                    className="delete_card_detail_btn"
                    onClick={() => {
                      openDeleteModal()
                      setCardId(client_card_id)
                    }}
                  >
                    <img className="delete_btn_img" src={delete_btn} alt="delete_btn" />
                  </button>
                )}
              </div>
            ))}

          {/* Add Credit Card */}
          <div className="text-center mt-4">
            <button className="btn btn-primary paid-cancel-btn w-100 mb-3 profile_save_btn" type="button" onClick={() => handleAddCreditCard()}>
              <i className="fa-solid fa-plus fa-xl me-2 add_card_icon" aria-hidden="true" />
              Add Credit Card
            </button>
          </div>
        </div>
      </div>

      {/* Add/Edit Credit Card Modal */}
      {showCreditCardModal && (
        <CustomModal isOpen={showCreditCardModal} toggle={toggleCreditCardModal} title="Add Credit Card" size="md">
          <AddEditCreditCard toggle={toggleCreditCardModal} setIsRefresh={setIsRefresh} />
        </CustomModal>
      )}
      {isDeleteModalOpen && (
        <DeletePopup isDeleteModalOpen={isDeleteModalOpen} toggle={openDeleteModal}>
          <div className="multi_btn_div">
            <button type="button" className="btn common-outline-btn w-100" onClick={openDeleteModal}>
              Cancel
            </button>
            <button type="submit" className="btn btn-danger common-field-btn w-100" onClick={handleCardDelete}>
              Delete
            </button>
          </div>
        </DeletePopup>
      )}
    </>
  )
}

export default PaymentMethod
